module.exports = __webpack_public_path__ + "img/86.6.CODm.e6416b24.png";